import React from 'react'
import { Labeled, TextField, TextFieldProps } from 'react-admin'

type Props = Omit<TextFieldProps, 'label'> & {
  label: string
}

const LabeledTextField: React.FC<Props> = ({ label, ...rest }) => {
  return (
    <Labeled label={label} sx={{ marginBottom: '16px' }}>
      <TextField {...rest} />
    </Labeled>
  )
}

export default LabeledTextField
